import { isToday, isYesterday } from "date-fns";
import { useIntl } from "react-intl";

import { useDateFnsFormat } from "@app/util/use-date-fns-format";

/**
 * Formats a run's processed date with relative wording for recent days:
 * today → "Vandaag om {tijd}", yesterday → "Gisteren om {tijd}", otherwise "dd-MM-yyyy HH:mm".
 */
export const useProcessedDate = (): ((date: Date) => string) => {
  const intl = useIntl();
  const { formatDate } = useDateFnsFormat();

  return (date: Date): string => {
    const time = formatDate(date, "HH:mm");
    if (isToday(date)) {
      return intl.formatMessage({ id: "productPageSync.date.today" }, { time });
    }
    if (isYesterday(date)) {
      return intl.formatMessage({ id: "productPageSync.date.yesterday" }, { time });
    }
    return formatDate(date, "dd-MM-yyyy HH:mm");
  };
};
